import { useConfig } from "config";

import { useFeatureFlag } from "features/feature-flags";

export default function useIsGoStudentLearningApp() {
  const { config } = useConfig();
  const isGoStudentLearningApp = (config &&
    config.isGoStudentLearningApp) as boolean;

  return !!useFeatureFlag("isGoStudentLearningApp") || isGoStudentLearningApp;
}
